export const selectMonitoreosEspectacularesState = (state) => state.monitoreosEspectaculares;

export const selectActaInicio = (state) => state.monitoreosEspectaculares.actaInicio;
export const selectActaCierre = (state) => state.monitoreosEspectaculares.actaCierre;

export const selectMonitoreosEspectacularesFormState = (state) =>
  state.monitoreosEspectaculares.form;
